module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.4f995fa4.otf";